import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { SPORT_ICONS } from "../sportIcons";
import { BRAND_FONT_FAMILY, brandRgba } from "../../utils/brandAssets";
import { colors } from "../../theme";

export const FanHubAvatar = ({
  src,
  name,
  accent,
  size = 104,
  sport,
}) => {
  const SportIcon = sport ? SPORT_ICONS[sport] : null;
  const initial = (name || "?").slice(0, 1).toUpperCase();

  return (
    <Box sx={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <Avatar
        src={src || undefined}
        alt={name}
        sx={{
          width: size,
          height: size,
          border: `2px solid ${accent}`,
          boxShadow: `0 0 0 6px ${brandRgba(accent, 0.16)}`,
          fontSize: size * 0.36,
          bgcolor: colors.paper,
        }}
      >
        {initial}
      </Avatar>
      {SportIcon && (
        <Box
          sx={{
            position: "absolute",
            right: -4,
            bottom: -4,
            width: Math.round(size * 0.29),
            height: Math.round(size * 0.29),
            borderRadius: "50%",
            bgcolor: colors.paper,
            border: `1px solid ${brandRgba(accent, 0.5)}`,
            color: accent,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SportIcon sx={{ fontSize: Math.round(size * 0.15) }} />
        </Box>
      )}
    </Box>
  );
};

export const FanHubHandle = ({ username }) => (
  <Typography
    sx={{
      color: "text.secondary",
      letterSpacing: "0.06em",
      textTransform: "none",
      fontSize: 13,
      fontWeight: 600,
    }}
  >
    @{username || "username"}
  </Typography>
);

export const FanHubDisplayName = ({ children, variant = "h3" }) => (
  <Typography
    variant={variant}
    fontWeight={800}
    sx={{
      fontFamily: BRAND_FONT_FAMILY,
      lineHeight: 1.05,
      letterSpacing: 0.4,
    }}
  >
    {children}
  </Typography>
);
